<kendo-dialog [title]="document().file_name" [width]="'95vw'" [height]="'90vh'" [minWidth]="800" [maxWidth]="1400" (close)="closed.emit()">
  <div style="overflow-y: auto; height: 100%; padding: 1rem">
    <div class="row g-4">
      <!-- Left Column: Document Info + Findings by Domain -->
      <div class="col-lg-8">
        <!-- Document Metadata -->
        <div class="card mb-4">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <div class="d-flex align-items-center gap-2 mb-2">
                  <span
                    class="file-type-badge"
                    [class.file-type-badge--pdf]="document().file_type === 'pdf'"
                    [class.file-type-badge--docx]="document().file_type === 'docx'"
                  >
                    {{ document().file_type | uppercase }}
                  </span>
                  <h5 class="mb-0">{{ document().file_name }}</h5>
                </div>
                <p class="text-muted small mb-1">
                  Uploaded {{ formatDate(document().uploaded_at) }} by {{ document().uploaded_by }}
                </p>
                <p class="text-muted small mb-0">
                  {{ document().statement_count }} extracted statements across {{ document().domains.length }} domains
                </p>
              </div>
              <button class="btn btn-primary btn-sm" (click)="viewFindings.emit({ documentId: document().id })">
                View All Findings
              </button>
            </div>

            @if (document().domains.length > 0) {
              <div class="mt-3">
                @for (domain of document().domains; track domain) {
                  <span class="badge bg-light text-dark me-1 mb-1">{{ getDomainDisplayName(domain) }}</span>
                }
              </div>
            }

            <!-- Evidence Sources Banner -->
            @if (evidenceSources().length > 0) {
              <div class="mt-3 pt-3 border-top">
                <div class="d-flex align-items-center gap-2 mb-2">
                  <h6 class="mb-0 small fw-bold">Validated Against:</h6>
                  <span class="text-muted small">{{ evidenceSources().length }} evidence source(s)</span>
                </div>
                <div class="d-flex flex-wrap gap-2">
                  @for (source of evidenceSources(); track source) {
                    <span class="badge bg-white text-dark border px-3 py-2 fw-medium">{{ source }}</span>
                  }
                </div>
              </div>
            }
          </div>
        </div>

        <!-- Findings by Domain Accordion -->
        <h6 class="mb-3">Findings by Domain</h6>
        @for (group of findingsByDomain(); track group.domain) {
          <div class="card mb-2">
            <div
              class="card-header d-flex justify-content-between align-items-center py-2 cursor-pointer"
              (click)="toggleDomain(group.domain)"
            >
              <div class="d-flex align-items-center gap-2">
                <span class="expand-icon">{{ isDomainExpanded(group.domain) ? '&#9660;' : '&#9654;' }}</span>
                <strong>{{ group.displayName }}</strong>
              </div>
              <div class="d-flex align-items-center gap-2">
                <span class="text-muted small">{{ group.validated }}/{{ group.total }} validated</span>
                <div class="progress" style="width: 80px; height: 6px">
                  <div
                    class="progress-bar bg-success"
                    [style.width.%]="(group.validated / group.total) * 100"
                  ></div>
                </div>
              </div>
            </div>

            @if (isDomainExpanded(group.domain)) {
              <div class="card-body p-0">
                <div class="list-group list-group-flush">
                  @for (finding of group.findings; track finding.id) {
                    <div class="list-group-item py-3">
                      <div class="d-flex justify-content-between align-items-start mb-1">
                        <strong class="small">{{ finding.title }}</strong>
                        <app-finding-status-badge [status]="finding.status"></app-finding-status-badge>
                      </div>
                      <p class="text-muted small mb-1">{{ finding.explanation }}</p>
                      <div class="d-flex gap-3">
                        @if (finding.evidence_source) {
                          <span class="text-muted small">Evidence: {{ finding.evidence_source }}</span>
                        }
                        @if (finding.source_reference) {
                          <span class="text-muted small">Source: {{ finding.source_reference }}</span>
                        }
                        <span class="text-muted small">Confidence: {{ finding.confidence }}</span>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>

      <!-- Right Column: Report Card + Evidence -->
      <div class="col-lg-4">
        @if (document().report_card) {
          <app-report-card-summary [reportCard]="document().report_card!"></app-report-card-summary>
        }

      </div>
    </div>
  </div>
</kendo-dialog>
